import React from "react";

const LOGO = "/armony-logo-white.png";

type Props = { className?: string; imgClassName?: string; tag?: string; bare?: boolean };

// Manual de marca: versión 1 (con slogan) en blanco, mínimo 90px de ancho en digital (h-7 ≈ 119px).
// El área de seguridad del logo queda libre: el sello "Contigo"/"Admin" va separado (gap-5) y en la
// tipografía de la marca, nunca pegado ni superpuesto al logotipo.
export const BrandLogo: React.FC<Props> = ({ className = "", imgClassName = "h-7", tag, bare = false }) => (
  <span className={`flex items-center gap-5 ${className}`} data-testid="brand-logo">
    {bare ? (
      <img src={LOGO} alt="Armony" className={`w-auto ${imgClassName}`} />
    ) : (
      <span className="bg-navy rounded-lg px-2.5 py-1.5 flex items-center">
        <img src={LOGO} alt="Armony" className={`w-auto ${imgClassName}`} />
      </span>
    )}
    {tag && (
      // Sobre azul (bare): celeste de marca #BDCDE6 (6,8:1). Sobre blanco: azul de marca.
      <span className={`text-[11px] uppercase tracking-[0.25em] font-semibold ${bare ? "text-brand-sky" : "text-navy"}`}>{tag}</span>
    )}
  </span>
);
